<template>
  <div
    v-if="!editFlag"
    class="Fuell-TableInput clickable"
    :class="{'Fuell-TableInput--disabled' : disabled}"
    role="button"
    @click="toggleEditFlag"
  >
    <template v-if="placeholderDisabled && disabled">
      {{$t(placeholderDisabled)}}
    </template>
    <template v-else-if="!hideCurrency">
      {{ value
    | currency('€', 2, {
              symbolOnLeft: false,
              thousandsSeparator: '.',
              decimalSeparator: ','
            })

    }}
    </template>
    <template v-else>
      {{value}}
    </template>
    <div class="Fuell-TableInput--icon-container">
      <div class="Fuell-TableInput--icon-container">
        <img
          class
          alt="manual-edit-icon"
          role="button"
          :src="require(`@/assets/img/icons/icon-pencil-${color}.svg`)"
        />
      </div>
    </div>
  </div>
  <div
    class="Fuell-TableInput--container"
    v-else
  >
    <currency-input
      class="Fuell-TableInput"
      :class="{'Fuell-TableInput--disabled' : disabled}"
      :allow-negative="allowNegative"
      :disabled="disabled"
      :currency="currencyValue"
      :precision="precision"
      :locale="locale"
      :ref="id"
      :value="value"
      @blur="handleBlur"
      @keydown="handleKeyDown"
    >
    </currency-input>
    <div class="Fuell-TableInput--icon-container clickable">
      <img
        class
        alt="manual-edit-icon"
        role="button"
        :src="require(`@/assets/img/icons/icon-pencil-${color}.svg`)"
      />

    </div>
  </div>

</template>

<script>
import { CurrencyInput, parse } from 'vue-currency-input'
export default {
  name: 'MoneyInput',
  props: {
    id: {
      type: String,
      default: 'MoneyInput'
    },
    value: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'blue'
    },
    placeholderDisabled: {
      type: String,
      default: 'expense_amount'
    },
    currency: {
      type: String,
      default: 'EUR'
    },
    locale: {
      type: String,
      default: 'ES'
    },
    allowNegative: {
      type: Boolean,
      default: false
    },
    hideCurrency: {
      type: Boolean,
      default: false
    },
    precision: {
      type: [Number, Object]
    }
  },
  components: {
    CurrencyInput
  },
  data () {
    return {
      editFlag: false,
      originalValue: 0,
      preventBlurOnKeyDown: false
    }
  },
  computed: {
    currencyValue () {
      return this.hideCurrency ? null : this.currency
    }
  },
  methods: {
    toggleEditFlag () {
      if (this.disabled) return
      this.editFlag = !this.editFlag
      if (this.editFlag) {
        setTimeout(() => {
          this.$refs[this.id].$el.focus()
          this.$refs[this.id].$el.select()
        }, 50)
        this.preventBlurOnKeyDown = false
      }
    },
    handleBlur (event) {
      const formatted = parse(event.target.value, { locale: 'de-DE' })

      if (formatted !== null && formatted !== this.originalValue && formatted >= 0 && !this.preventBlurOnKeyDown) {
        this.$emit('update:value', formatted)
        this.$emit('change', formatted)
      }
      this.toggleEditFlag()
    },
    handleKeyDown (event) {
      if (event.keyCode === 13) {
        const formatted = parse(event.target.value, { locale: 'de-DE' })

        if (formatted !== null && formatted !== this.originalValue && formatted >= 0) {
          this.$emit('update:value', formatted)
          this.$emit('change', formatted)
          this.toggleEditFlag()
          this.preventBlurOnKeyDown = true
        }
      }
    }
  },
  created () {
    this.originalValue = this.value
  },
  watch: {
    value: function (newV, oldV) {
      this.originalValue = newV
    }
  }

}
</script>
